import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-publication-faculty',
  templateUrl: './publication-faculty.component.html',
  styleUrls: ['./publication-faculty.component.css']
})
export class PublicationFacultyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Publication (Faculty)",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Publication (Faculty)",
  }
}
